import { render, staticRenderFns } from "./cargoDetail.vue?vue&type=template&id=021c0f57&scoped=true&"
import script from "./cargoDetail.vue?vue&type=script&lang=js&"
export * from "./cargoDetail.vue?vue&type=script&lang=js&"
import style0 from "./cargoDetail.vue?vue&type=style&index=0&id=021c0f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c0f57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021c0f57')) {
      api.createRecord('021c0f57', component.options)
    } else {
      api.reload('021c0f57', component.options)
    }
    module.hot.accept("./cargoDetail.vue?vue&type=template&id=021c0f57&scoped=true&", function () {
      api.rerender('021c0f57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/components/Warehousing/cargoDetail.vue"
export default component.exports